import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form/immutable'
import { withTranslation } from 'react-i18next'

import Button from 'app/components/ButtonDefault'
import Input from 'app/components/Input'
import InputPhoneNumber from 'app/domains/common/InputPhoneNumber'
import * as LOGIN_ERRORS from 'app/constants/loginErrors'
import ErrorBlock from 'app/components/ErrorBlock'

import './styles.scss'

const bc = 'login-form'

const LoginForm = ({
  t,
  form,
  handleSubmit,
  title,
  subtitle,
  buttonText,
  isEmailForm,
  pristine,
  isSubmitting,
  loginError,
}) => (
  <form onSubmit={handleSubmit}>
    <div className={`${bc}__title`}>{title}</div>
    {subtitle && <div className={`${bc}__subtitle`}>{subtitle}</div>}
    {isEmailForm ? (
      <Field
        name="email"
        type="email"
        dataTest="login-email"
        placeholder="example@email.com"
        component={Input}
        autoFocus
        label={t('Enter email')}
        className={`${bc}__input`}
        errorBlock
      />
    ) : (
      <InputPhoneNumber errorBlock isRequired className={`${bc}__input`} form={form} />
    )}
    <Button
      primary
      type="submit"
      dataTest={isEmailForm ? "login-email-button" : ""}
      className={`${bc}__button`}
      disabled={pristine || isSubmitting}
      submitting={isSubmitting}
    >
      {buttonText}
    </Button>
    {loginError && (
      <ErrorBlock organizationDisabled={loginError === LOGIN_ERRORS.ORGANIZATION_DISABLED}>
        {loginError === LOGIN_ERRORS.ORGANIZATION_DISABLED ? (
          <span>
            {t('Please contact us at')}
            <a href="mailto:happy@prohabits.com">happy@prohabits.com</a>
            {t('to get you back on track')}
          </span>
        ) : (
          <span>{t(loginError)}</span>
        )}
      </ErrorBlock>
    )}
  </form>
)

LoginForm.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonText: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
}

export default withTranslation('login')(LoginForm)
